import BaseSallaForm from './BaseSallaForm';

const SallaAutomationForm = () => (
	<BaseSallaForm
		showStatuses
		showEmail
		showPassword
		showOTP
		showCredentialsApproval
		advanceSettingsFields={['defaultWarehouse', 'prefix']}
	/>
);

export default SallaAutomationForm;
